<template>
  <div
    class="select-wrapper relative"
    :class="{ error: hasErrors }"
  >
    <div class="flex between-xs">
      <label class="inline-block">
        <span class="inline-block">
          {{ label }}
        </span>
        <span
          v-if="required"
          class="c-primary inline-block"
        >*</span>
      </label>
    </div>
    <div class="relative">
      <select
        :name="name"
        class="select"
        :class="{
          'empty': !selected,
          'error': hasErrors
        }"
        :autocomplete="autocomplete"
        @focus="$emit('focus')"
        @blur="$emit('blur')"
        @change="$emit('change', $event.target.value)"
        @input="$emit('input', $event.target.value)"
      >
        <option
          v-if="!selected"
          disabled
          selected
          value
        >
          {{ placeholder }}
        </option>
        <option
          v-for="(option, key) in options"
          :key="key"
          :value="option.value"
          v-bind="{selected: option.value === selected}"
        >
          {{ option.label }}
        </option>
      </select>
      <i class="icon select-chevron icon-expand-arrow" />
    </div>
    <validation-messages
      v-if="validations"
      :validations="validations"
    />
  </div>
</template>

<script>
import ValidationMessages from './ValidationMessages.vue'

export default {
  name: 'BaseSelect',
  components: {
    ValidationMessages
  },
  props: {
    id: {
      type: String,
      required: false,
      default: ''
    },
    name: {
      type: String,
      required: false,
      default: ''
    },
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    selected: {
      type: [String, Number],
      required: false,
      default: ''
    },
    placeholder: {
      type: [String, Number],
      required: false,
      default: ''
    },
    autocomplete: {
      type: String,
      required: false,
      default: ''
    },
    validations: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    hasErrors () {
      if (this.validations && this.validations.length > 0) {
        return this.validations.some(validation => !!validation.condition)
      }

      return false
    }
  }
}
</script>
